/**
 * CA 19 (CU-869fmjzrg): "Price curve of this date" from another BI dashboard — the query string of "Price curve of a
 * date" for the same office, rental length, cars, market filter, statistic and same-date choice, and that date or that
 * week. Shared (not in the price curve's folder), so no dashboard imports from another; the keys are the ones its
 * `view.js` reads (its test reads this back).
 *
 * A week column is a week whatever its number of days (Season cuts the edge weeks of a view: `by` says it); the curve
 * takes the whole Sunday-to-Saturday week from any of its days. Pure and alias-free.
 */
export function priceCurveParams({ view, dates, by = null }) {
	const days = [...(dates || [])].sort()
	const week = by ? by === 'week' : days.length > 1
	const p = new URLSearchParams()
	p.set('view', 'curve')
	if (view.office) p.set('office', String(view.office))
	if (view.lor) p.set('lor', String(view.lor))
	p.set('stat', view.stat || 'min')
	p.set('same', view.cmp === 'ly' && view.same ? '1' : '0')
	p.set('ly', '1')
	p.set('pick', week ? 'week' : 'date')
	p.set('when', 'fixed')
	if (days[0]) p.set('date', days[0])
	if (view.cars && view.cars !== 'all' && view.carsIds?.length) {
		p.set('cars', view.cars)
		p.set('carsIds', view.carsIds.join(','))
	}
	if (view.tier) p.set('tier', String(view.tier))
	else if (view.providers?.length) p.set('providers', view.providers.join(','))
	if (view.office) p.set('offices', String(view.office))
	if (days.length) p.set('dates', days.join(','))
	p.set('weeks', 'default')
	return p.toString()
}
